import axios from 'axios'

class TokenService {
  getTokenPool() {
    return axios.get('/token-pool')
  }
}

export default new TokenService()
